module.exports = __webpack_public_path__ + "static/band-dan-55d02247e632dff93f3ddf65714d6c3c.jpg";